import { TranslateService } from '@ngx-translate/core';
import { get } from 'lodash';

import { DocumentTypesUppercaseEnum } from 'common/src/modules/modals/modals-common/link-document-modal/enums/ducument-types.enum';

export type BulkStatusToastDocType =
  DocumentTypesUppercaseEnum.OIN | DocumentTypesUppercaseEnum.IIN | DocumentTypesUppercaseEnum.CRN |
  DocumentTypesUppercaseEnum.PMNT | DocumentTypesUppercaseEnum.DN | DocumentTypesUppercaseEnum.PO |
  DocumentTypesUppercaseEnum.SBC | DocumentTypesUppercaseEnum.OFR | DocumentTypesUppercaseEnum.SO | DocumentTypesUppercaseEnum.BA |
  DocumentTypesUppercaseEnum.COST_CENTER | 'EMAIL' | 'OVERDUE_NOTICE' | 'VAT_REPORT' |
  'PARTNER' | 'OIN_TEMPLATE' | 'PMNT_TEMPLATE' | 'BUSINESS_PARTNER' | 'ECO_ORDER' | 'ORDER' |
  'EMPLOYEE' | 'PRODUCT' | 'BUNDLE' | 'RECORD' | 'DOCUMENT';

// BULK.ACTION's own key set (en/de.json)
export type BulkStatusToastAction =
  'DELETED' | 'DELETED_PERMANENTLY' | 'CANCELED' | 'RESTORED' | 'APPROVED' | 'DECLINED' | 'SENT' |
  'SHIPPED' | 'TAKEN_BACK' | 'PAUSED' | 'ACTIVATED' | 'PROCEEDED' | 'DEACTIVATED' | 'BOOKED' | 'SUBMITTED' |
  'MOVED' | 'ECO_ACTIVATED' | 'ECO_DEACTIVATED' | 'UPDATED';

export interface BulkStatusToastKeys {
  docType: BulkStatusToastDocType;
  action: BulkStatusToastAction;
}

export interface BulkResponseCounts {
  requested: number;
  succeeded: number;
}

export function getBulkResponseCounts(response: any, total: number): BulkResponseCounts {
  const data = get(response, 'data');
  if (Array.isArray(data)) {
    return { requested: total, succeeded: data.length };
  }
  return {
    requested: get(data, 'requestedCount', total),
    succeeded: get(data, 'succeededCount', total),
  };
}

export function getBulkDocTypeName(translate: TranslateService, docType: BulkStatusToastDocType, count: number): string {
  return translate.instant(count === 1 ? `BULK.DOC_TYPE_SINGULAR.${docType}` : `BULK.DOC_TYPE.${docType}`);
}

export function showBulkStatusToast(
  translate: TranslateService,
  showMsg: (type: 'success' | 'warning' | 'error', message: string) => void,
  total: number,
  succeed: number,
  keys: BulkStatusToastKeys,
): void {
  const action = translate.instant(`BULK.ACTION.${keys.action}`);

  if (succeed === 0) {
    const docTypePlural = translate.instant(`BULK.DOC_TYPE_PLURAL.${keys.docType}`);
    showMsg('error', translate.instant('BULK.NONE', { docType: docTypePlural, action }));
    return;
  }

  if (total === succeed && total === 1) {
    const docTypeSingular = translate.instant(`BULK.DOC_TYPE_SINGULAR.${keys.docType}`);
    showMsg('success', translate.instant('BULK.ONE_SUCCESS', { docType: docTypeSingular, action }));
    return;
  }

  const docType = translate.instant(`BULK.DOC_TYPE.${keys.docType}`);
  if (total === succeed) {
    showMsg('success', translate.instant('BULK.N_SUCCESS', { count: total, docType, action }));
  } else {
    const partialKey = succeed === 1 ? 'BULK.ONE_OF_N_SUCCESS' : 'BULK.N_OF_N_SUCCESS';
    showMsg('warning', translate.instant(partialKey, { sent: succeed, total, docType, action }));
  }
}
